import React from 'react';

import { ErrorMessage, useFormikContext } from 'formik';

import { Error } from './styles';

interface FormErrorProps {
  name: string;
  className?: string;
}

const FormError: React.FC<FormErrorProps> = ({ name, className }) => {
  const { status } = useFormikContext<any>();

  return (
    <>
      <ErrorMessage
        name={name}
        render={(msg) => {
          return (
            <Error data-cy={`error_${name}`} className={className}>
              {msg}
            </Error>
          );
        }}
      />
      {status &&
        status[name] &&
        status[name].map((error: string, index: number) => (
          <Error key={index} className={className}>
            {error}
          </Error>
        ))}
    </>
  );
};

export default FormError;
